import { isPlatformBrowser } from '@angular/common';
import { DOCUMENT, inject, Injectable, PLATFORM_ID, signal } from '@angular/core';

@Injectable({
    providedIn: 'root',
})
export class SidebarService {
    public isMobileMenuOpen = signal(false);

    private readonly document = inject(DOCUMENT);
    private readonly platformId = inject(PLATFORM_ID);

    constructor() {
        if (isPlatformBrowser(this.platformId)) {
            this.document.addEventListener('click', this.onDocumentClick);
        }
    }

    private readonly onDocumentClick = (event: MouseEvent) => {
        const sidebarMenu = this.document.getElementById('sidebar-menu');
        const targetNode = event.target as Node | null;

        if (!sidebarMenu || !targetNode) {
            return;
        }

        if (this.isMobileMenuOpen() && !sidebarMenu.contains(targetNode)) {
            this.hideMobileMenu();
        }
    };

    public toggleMobileMenu() {
        if (this.isMobileMenuOpen()) {
            this.hideMobileMenu();
        } else {
            this.isMobileMenuOpen.set(true);
            this.document.body.style.overflow = 'hidden';
        }
    }

    public hideMobileMenu() {
        this.removeOverflow();
        this.isMobileMenuOpen.set(false);
    }

    public removeOverflow() {
        this.document.body.style.removeProperty('overflow');
    }
}
